import { useEffect, useState } from 'react';
import { useNavigate, useParams } from "react-router-dom";
import PageMenu from 'components/blocks/PageMenu/PageMenu';
import IconArrowGray from "../../../../img/icons/svg/botones/flecha-big-gris.svg";
import Loader from 'components/blocks/Loader/Loader';
import ErrorDisplay from 'components/blocks/ManagementNewForms/ErrorManagement/ErrorPantalla';
import useDecode from 'hooks/useDecode';
import SolicitudGastosTransporte from './SolicitudGastosTransporte';
import useGetSolicitudGastosTransporteByID from 'services/record/SolicitudGastosTransporte/useGetSolicitudGastosTransporteByID';

const HistorialSolicitudGastosTransporte = ({ expedienteId = null, origen = null }) => {
    const decoded = useDecode("token");
    const userId = decoded?.extension_id;
    const [data, setData] = useState(null);
    const navigate = useNavigate();
    const { getSolicitudGastosTransporteByID, loadingGetSolicitudGastosTransporteByID, statusGetSolicitudGastosTransporteByID } = useGetSolicitudGastosTransporteByID();
    const { idprestacion, idform } = useParams<Record<string, string>>();
    const expedienteIdByOrigen = Number(origen) === 1 ? (expedienteId ?? null) : null;
    const dataUserWithExpedienteByOrigen = (payload: any) => (
        expedienteIdByOrigen !== null && expedienteIdByOrigen !== undefined
            ? { ...payload, ExpedienteIdByOrigen: expedienteIdByOrigen }
            : payload
    );

    useEffect(() => {
        const actualUrl = window.location.href;

        if (!actualUrl.includes('/mis-gestiones/formularios')) {
            const prestacionId = idprestacion?.split('_')[1] || idprestacion;
            const formId = idform;

            if (userId && prestacionId && formId) {
                getSolicitudGastosTransporteByID(userId, prestacionId, formId, (payload) => setData(dataUserWithExpedienteByOrigen(payload))).catch(() => undefined);
            }
        }
    }, [expedienteIdByOrigen, idform, idprestacion, userId]);

    return (
        <div>
            <PageMenu title={'Solicitud Gastos Transporte'}>
                <div className="btns-header-container">
                    <button aria-label="Volver atrás" onClick={() => navigate(-1)}>
                        <img src={IconArrowGray} alt="" />
                    </button>
                </div>
            </PageMenu>

            {loadingGetSolicitudGastosTransporteByID ?
                <Loader activeLoader={true} label="Cargando Formulario" />
                : statusGetSolicitudGastosTransporteByID?.status && ![200, 204].includes(statusGetSolicitudGastosTransporteByID.status) ?
                    <ErrorDisplay descripcionError={statusGetSolicitudGastosTransporteByID.statusText} />
                    : data && <SolicitudGastosTransporte dataUser={data} info={false} />
            }
        </div>
    );
};

export default HistorialSolicitudGastosTransporte;
